<div class="modal-header">
  <h4 class="modal-title">{{'choiceActionLocalBackupComponent.title' | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner overflow-xh">
    <p>{{'global.label.choiceActionComponents' | translate}}</p>
    <div class="ps-5">
      <div class="form-check">
        <input type="radio" class="form-check-input" id="radio1" name="radioGroup" [value]="types[0]" [(ngModel)]="actionType"
               [disabled]="importDisabled">
        <label id="wsp_import_radio" class="form-check-label" for="radio1" [innerHTML]="'choiceActionLocalBackupComponent.label.import_project' | translate"></label>
      </div>
      <div class="form-check mt-3">
        <input type="radio" class="form-check-input" id="radio2" name="radioGroup" [value]="types[1]" [(ngModel)]="actionType" [disabled]="exportDisabled">
        <label id="wsp_export_radio" class="form-check-label" for="radio2" [innerHTML]="'choiceActionLocalBackupComponent.label.export_project' | translate"></label>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.close' | translate}}</button>
  <button id="step_forward" class="btn btn-primary btn-forward" (click)="onConfirm()">{{'global.label.next' | translate}}</button>
</div>
